<template>
    <div :name="`name${data.qid}`"  class="test_question list">
        <p class="title" 
            :style="{
                fontSize: bandingstyle.appearancePhone.fontStemSize+'px',
                color:bandingstyle.appearancePhone.fontStemColor,
                fontWeight: bandingstyle.appearancePhone.fontStemBold,
                fontStyle: bandingstyle.appearancePhone.fontStemItalic,
                textDecoration: bandingstyle.appearancePhone.fontStemUnderline
            }"
            
        >
            <span v-if="data.mustanswer" class="required"></span>
		    <HtmlClickImgEnlarge :content="data.questionsName"/>
		</p>
        <div class="input_box"> 
            <!-- 单选 -->
            <div v-if="data.questionsTypeId == '8'" >
                <template v-if="data.groupingOptionList && data.groupingOptionList.length > 0">
                    <div class="group-list" v-for="item in data.groupingOptionList" :key="item.gid">
                        <p class="group-title">{{item.groupName}}</p>
                        <el-radio-group
                            v-model="data.userAnswer" 
                            class="option-box group-radio"
                            @change="userAnswerChange">
                            <template v-for="info in item.optionList" >
                                <el-radio 
                                    v-if="info.show == undefined || info.show == true"
                                    class="option" 
                                    :key="info.oid" 
                                    :label="info.oid"
                                    border
                                    size="medium"
                                    :style="{
                                        fontSize: bandingstyle.appearancePhone.fontOptionSize+'px',
                                        color:bandingstyle.appearancePhone.fontOptionColor,
                                        fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                                        fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                                        textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
                                    }"
                                ><HtmlClickImgEnlarge :content="info.labelName"/>
                                </el-radio>
                                <div 
                                    :key="`op${info.oid}`" 
                                    v-if="info.haveInput && data.userAnswer == info.oid"
                                    class="other-input">
                                    <el-input
                                        size="medium"
                                        :placeholder="$t('UserAnswer.PleaseEnter')"
                                        v-model="info.inputValue"
                                        >
                                    </el-input>
                                    <i v-if="info.format == 7 && !isPc" @click="keyboardShowClick(info.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
                                    <IDNumberKeyboard :ref="info.oid" :userAnswer="info.inputValue" @updata="(val) => info.inputValue = val"></IDNumberKeyboard>
                                </div>
                            </template>
                        </el-radio-group>
                    </div>
                    <div class="group-list" v-if="data.optionList.length > 0">
                        <p class="group-title">其他</p>
                        <el-radio-group
                            v-model="data.userAnswer" 
                            class="option-box group-radio"
                            @change="userAnswerChange">
                            
                            <template v-for="info in data.optionList">
                                <el-radio 
                                    v-if="info.show == undefined || info.show == true"
                                    class="option" 
                                    :key="info.oid" 
                                    :label="info.oid"
                                    border
                                    size="medium"
                                    :style="{
                                        fontSize: bandingstyle.appearancePhone.fontOptionSize+'px',
                                        color:bandingstyle.appearancePhone.fontOptionColor,
                                        fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                                        fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                                        textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
                                    }"
                                ><HtmlClickImgEnlarge :content="info.labelName"/>
                                    
                                </el-radio>
                                <div 
                                    :key="`op${info.oid}`" 
                                    v-if="info.haveInput && data.userAnswer == info.oid"
                                    class="other-input">
                                    <el-input
                                        size="medium"
                                        :placeholder="$t('UserAnswer.PleaseEnter')"
                                        v-model="info.inputValue"
                                        >
                                    </el-input>
                                    <i v-if="info.format == 7 && !isPc" @click="keyboardShowClick(info.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
                                    <IDNumberKeyboard :ref="info.oid" :userAnswer="info.inputValue" @updata="(val) => info.inputValue = val"></IDNumberKeyboard>
                                </div>
                            </template>
                        </el-radio-group>
                    </div>
                </template>
                <el-radio-group
                    v-else
                    v-model="data.userAnswer" 
                    class="option-box group-radio"
                    @change="userAnswerChange">
                    <template v-for="info in data.optionList" >
                        <el-radio 
                            v-if="info.show == undefined || info.show == true"
                            class="option" 
                            :key="info.oid" 
                            :label="info.oid"
                            border
                            size="medium"
                            :style="{
                                fontSize: bandingstyle.appearancePhone.fontOptionSize+'px',
                                color:bandingstyle.appearancePhone.fontOptionColor,
                                fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                                fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                                textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
                            }"
                        ><HtmlClickImgEnlarge :content="info.labelName"/>
                        </el-radio>
                        <div 
                            :key="`op${info.oid}`" 
                            v-if="info.haveInput && data.userAnswer == info.oid"
                            class="other-input">
                            <el-input
                                size="medium"
                                :placeholder="$t('UserAnswer.PleaseEnter')"
                                v-model="info.inputValue"
                                >
                            </el-input>
                            <i v-if="info.format == 7 && !isPc" @click="keyboardShowClick(info.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
                            <IDNumberKeyboard :ref="info.oid" :userAnswer="info.inputValue" @updata="(val) => info.inputValue = val"></IDNumberKeyboard>
                        </div>
                    </template>
                </el-radio-group>
            </div>
            <!-- 多选 -->
            <div v-else-if="data.questionsTypeId == '10'">
                <template v-if="data.groupingOptionList && data.groupingOptionList.length > 0">
                    <div class="group-list" v-for="item in data.groupingOptionList" :key="item.gid">
                        <p class="group-title">{{item.groupName}}</p>
                        <el-checkbox-group v-model="data.userAnswerArr" class="option-box group-checkbox"
                        @change="userAnswerChange">
                        
                            <template v-for="info in item.optionList" >
                                <el-checkbox 
                                    v-if="info.show == undefined || info.show == true"
                                    class="option" 
                                    :key="info.oid" 
                                    :label="info.oid"
                                    :disabled="data.validateMsg.indexOf('最多') != -1 
                                        && data.validate 
                                        && data.userAnswerArr.indexOf(info.oid) == -1
                                    "
                                    :style="{
                                        fontSize: bandingstyle.appearancePhone.fontOptionSize+'px',
                                        color:bandingstyle.appearancePhone.fontOptionColor,
                                        fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                                        fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                                        textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
                                    }"
                                    border
                                    size="medium"
                                ><HtmlClickImgEnlarge :content="info.labelName"/>
                                <div 
                                    :key="`op${info.oid}`" 
                                    v-if="info.haveInput && data.userAnswerArr.indexOf(info.oid) !== -1"
                                    class="other-input">
                                    <el-input
                                        size="medium"
                                        :placeholder="$t('UserAnswer.PleaseEnter')"
                                        v-model="info.inputValue"
                                        >
                                    </el-input>
                                    <i v-if="info.format == 7 && !isPc" @click="keyboardShowClick(info.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
                                    <IDNumberKeyboard :ref="info.oid" :userAnswer="info.inputValue" @updata="(val) => info.inputValue = val"></IDNumberKeyboard>
                                </div>
                                </el-checkbox>
                            </template>
                        </el-checkbox-group>
                    </div>
                    <div class="group-list" v-if="data.optionList.length > 0">
                        <p class="group-title">其他</p>
                        <el-checkbox-group v-model="data.userAnswerArr" class="option-box group-checkbox"
                        @change="userAnswerChange">
                            <template v-for="info in data.optionList" >
                                <el-checkbox 
                                    v-if="info.show == undefined || info.show == true"
                                    class="option" 
                                    :key="info.oid" 
                                    :label="info.oid"
                                    :disabled="data.validateMsg.indexOf('最多') != -1 
                                        && data.validate 
                                        && data.userAnswerArr.indexOf(info.oid) == -1
                                    "
                                    :style="{
                                        fontSize: bandingstyle.appearancePhone.fontOptionSize+'px',
                                        color:bandingstyle.appearancePhone.fontOptionColor,
                                        fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                                        fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                                        textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
                                    }"
                                    border
                                    size="medium"
                                ><HtmlClickImgEnlarge :content="info.labelName"/>
                                </el-checkbox>
                                <div 
                                    :key="`op${info.oid}`" 
                                    v-if="info.haveInput && data.userAnswerArr.indexOf(info.oid) !== -1"
                                    class="other-input">
                                    <el-input
                                        size="medium"
                                        :placeholder="$t('UserAnswer.PleaseEnter')"
                                        v-model="info.inputValue"
                                        >
                                    </el-input>
                                    <i v-if="info.format == 7 && !isPc" @click="keyboardShowClick(info.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
                                    <IDNumberKeyboard :ref="info.oid" :userAnswer="info.inputValue" @updata="(val) => info.inputValue = val"></IDNumberKeyboard>
                                </div>
                             </template>
                        </el-checkbox-group>
                    </div>
                </template>
                <el-checkbox-group  v-else v-model="data.userAnswerArr" class="option-box group-checkbox"
                @change="userAnswerChange">
                    <template v-for="info in data.optionList" >
                        <el-checkbox 
                            v-if="info.show == undefined || info.show == true"
                            class="option" 
                            :key="info.oid" 
                            :label="info.oid"
                            :disabled="data.validateMsg.indexOf('最多') != -1 
                                && data.validate 
                                && data.userAnswerArr.indexOf(info.oid) == -1
                            "
                            :style="{
                                fontSize: bandingstyle.appearancePhone.fontOptionSize+'px',
                                color:bandingstyle.appearancePhone.fontOptionColor,
                                fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                                fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                                textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
                            }"
                            border
                            size="medium"
                        ><HtmlClickImgEnlarge :content="info.labelName"/>
                        </el-checkbox>
                        <div 
                            :key="`op${info.oid}`" 
                            v-if="info.haveInput && data.userAnswerArr.indexOf(info.oid) !== -1"
                            class="other-input">
                            <el-input
                                size="medium"
                                :placeholder="$t('UserAnswer.PleaseEnter')"
                                v-model="info.inputValue"
                                >
                            </el-input>
                            <i v-if="info.format == 7 && !isPc" @click="keyboardShowClick(info.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
                            <IDNumberKeyboard :ref="info.oid" :userAnswer="info.inputValue" @updata="(val) => info.inputValue = val"></IDNumberKeyboard>
                        </div>
                    </template>
                </el-checkbox-group>
            </div>
            <!-- 判断  -->
            <el-radio-group 
                v-if="data.questionsTypeId == '12'" 
                v-model="data.userAnswer" 
                class="option-box group-radio"
                @change="userAnswerChange"
            >
                <template v-for="info in data.optionList" >
                    <el-radio 
                        v-if="info.show == undefined || info.show == true"
                        class="option"
                        :key="info.oid" 
                        :label="info.oid"
                        :style="{
                            fontSize: bandingstyle.appearancePhone.fontOptionSize+'px !important',
                            color:bandingstyle.appearancePhone.fontOptionColor,
                            fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                            fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                            textDecoration: bandingstyle.appearancePhone.fontOptionUnderline,
                        }"
                        border
                        size="medium"
                    ><HtmlClickImgEnlarge :content="info.labelName"/>
                        <div 
                            :key="`op${info.oid}`" 
                            v-if="info.haveInput && data.userAnswer == info.oid"
                            class="other-input">
                            <el-input
                                size="medium"
                                :placeholder="$t('UserAnswer.PleaseEnter')"
                                v-model="info.inputValue"
                                >
                            </el-input>
                            <i v-if="info.format == 7 && !isPc" @click="keyboardShowClick(info.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
                            <!-- <IDNumberKeyboard :ref="info.oid" :userAnswer="info.inputValue" @updata="(val) => info.inputValue = val"></IDNumberKeyboard> -->
                        </div>
                    </el-radio>
                </template>
            </el-radio-group>
            <!-- 下拉题 -->
            <el-select 
                :placeholder="$t('UserAnswer.PleaseSelect')" 
                :popper-append-to-body="false" 
                v-else-if="data.questionsTypeId == '9'" 
                v-model="data.userAnswer" 
                @change="userAnswerChange">
                <template v-for="info in data.optionList" >
                    <el-option
                        v-if="info.show == undefined || info.show == true"
                        :key="info.oid" 
                        :label="$functions.filterHtmlTag(info.labelName)"
                        :value="info.oid">
                        <HtmlClickImgEnlarge :content="info.labelName"/>
                    </el-option>
                </template>
            </el-select>
            <div v-show="data.validate && data.validateMsg.indexOf('最多') == -1" class="form-item__error">{{data.validateMsg}}</div>
        </div>
    </div>
</template>

<script>
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue'
import IDNumberKeyboard from '@/components/IDNumberKeyboard/index.vue'
export default {
    components: {
        HtmlClickImgEnlarge,
        IDNumberKeyboard
    },
    props: {
        data: {},
        bandingstyle:{},
    },
    data() {
        return {
            mutexList: [],
            influenceList: [],
			isPc: true
        }
    },
    watch: {
        'data.userAnswerArr': {
            handler(newV, oldV) {
                if(this.data.questionsTypeId == 10) {
                    if (oldV) {
                        let add = newV.filter(v => !oldV.some((item) => item === v))[0]
                        if (add) this.getMutex(add, '', 'add')
                        let del = oldV.filter(v => !newV.some((item) => item === v))[0]
                        if (del) this.getMutex('', del, 'del') 
                    }
                }
            }
        }
    },
    created() {
		this.isPc = this.$functions.isPC()
        
        // console.log(this.data.userAnswerArr)
    },
    methods: {
        keyboardShowClick(name) {
            const keyboardRef = this.$refs[name];
            if (keyboardRef && keyboardRef.length > 0) {
                keyboardRef[0].keyboardShowClick();
            } else if (keyboardRef) {
                keyboardRef.keyboardShowClick();
            } else {
                console.error('未找到对应的组件实例');
            }
        },
        getMutex (add, del, state) {
            
            let changeOid = add || del
            // console.log(add)
            if (!changeOid) return
            let { mutexList, influenceList} = this.data

            // 互斥
            if (mutexList) {
                this.setMutex(mutexList, changeOid, state)
            }

            // 互相影响
            if (influenceList) {
                this.setInfluence(influenceList, changeOid, state)
            }
        },
        setMutex(mutexList, changeOid, state) {
            mutexList.forEach(info => {
                let isOk = false
                if (info.oneList.length > 0 && info.twoList.length > 0) isOk = true
                if (isOk) {
                    if (info.oneList.indexOf(changeOid) != -1 && state == 'add') {
                        this.data.userAnswerArr = this.data.userAnswerArr.filter(twoOid => {
                            return info.twoList.indexOf(twoOid) == -1
                        })
                    }
                    if (info.twoList.indexOf(changeOid) != -1 && state == 'add') {
                        this.data.userAnswerArr = this.data.userAnswerArr.filter(twoOid => {
                            return info.oneList.indexOf(twoOid) == -1
                        })
                    }
                }
            })
        },
        setInfluence(influenceList, changeOid, state) {
            influenceList.forEach(info => {
                let index = info.oneList.findIndex((oid) => {
                    return changeOid == oid
                })
                if (index != -1 && state == 'del') {
                    this.data.userAnswerArr = this.data.userAnswerArr.filter(userAnswer => {
                        return info.oneList.indexOf(userAnswer) == -1
                    })
                } else if (index != -1 && state == 'add') {
                    this.data.userAnswerArr = this.unique([...this.data.userAnswerArr,...info.oneList])
                }
            })
        },
        unique(arr) {
            return Array.from(new Set(arr))
        },
        userAnswerChange(){
            this.$emit('userAnswerChange', this.data)
        }
    }
}
</script>

<style lang="scss" scoped>
.test_question{
    .option-box{
        display: flex;
        flex-direction: column;
        // padding-left: 25px;
        .option+.option{
            margin-top: 10px;
        }
        .option{
            display: flex;
            align-items: center;
            /deep/.el-radio__label{
                display: flex;
                align-items: center;
            }
            /deep/.el-checkbox__label{
                display: flex;
                align-items: center;
            }
        }
        .other-input{
            position: relative;
            width: 100%;
            margin: 10px 0;
            /deep/.el-input__inner{
                // background-color: #f1f3f680;
                // color:#333;
                border: 1px solid #409EFF;
            }
            .keyboard{
                position: absolute;    
                top: 8px;
                right: 8px;
                color: #f8a430;
                top: 50%; 
                transform: translateY(-50%);
                padding: 10px;
            }
        }
    }
}
.required::before{
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
/deep/.el-checkbox__label,
/deep/.el-radio__label{
    font-size: inherit;
    text-decoration: inherit;
    display: flex;
    align-items: center;
    white-space: normal;
    word-break: break-all;
}
.el-radio.is-bordered,
.el-checkbox.is-bordered{
    padding: 9px 5px 9px 10px;
    height: inherit;
    line-height: 1.3;
}
.el-radio.is-bordered+.el-radio.is-bordered,
.el-checkbox.is-bordered+.el-checkbox.is-bordered{
    margin-left: 0;
}
.el-radio, .el-checkbox{
    margin-right: 0;
}
.group-title{
    font-size: 15px;
    color: #666666;
    margin-bottom: 10px;
}
.group-list+.group-list{
     margin-top: 20px;
}
.group-radio,
.group-checkbox{
    padding-left: 10px;
}
.el-select{
    width: calc(100% - 20px);
    margin-left: 20px;
}
</style>
